// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
export const EMPTY_FUNCTION: Function = () => {};
